import React, { useEffect } from 'react';
import '../../styles/TopographicBackground.css';

function TopographicBackground() {
  useEffect(() => {
    const topography = document.getElementById('topography');
    const layers = document.querySelectorAll('.layer, .contour');

    let mouseX = 0;
    let mouseY = 0;
    let currentX = 0;
    let currentY = 0;

    // Mouse parallax
    const handleMouseMove = (e) => {
      mouseX = (e.clientX / window.innerWidth) * 2 - 1;
      mouseY = (e.clientY / window.innerHeight) * 2 - 1;
    };

    // Touch parallax for mobile
    const handleTouchMove = (e) => {
      if (e.touches.length > 0) {
        const touch = e.touches[0];
        mouseX = (touch.clientX / window.innerWidth) * 2 - 1;
        mouseY = (touch.clientY / window.innerHeight) * 2 - 1;
      }
    };

    const handleTouchEnd = () => {
      mouseX = 0;
      mouseY = 0;
    };

    // Smooth animation loop
    const animate = () => {
      currentX += (mouseX - currentX) * 0.1;
      currentY += (mouseY - currentY) * 0.1;

      layers.forEach(layer => {
        const speed = parseFloat(layer.getAttribute('data-speed')) || 1;
        const x = currentX * speed * 8;
        const y = currentY * speed * 8;
        layer.style.translate = `${x}px ${y}px`;
      });

      const rotateX = currentY * 4;
      const rotateY = -currentX * 4;
      topography.style.transform = `rotate(-15deg) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

      requestAnimationFrame(animate);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd);
    animate();

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <div className="topographic-container">
      <div className="topography" id="topography">
        <div className="layer layer11" data-speed="1"></div>
        <div className="layer layer10" data-speed="1.5"></div>
        <div className="layer layer9" data-speed="2"></div>
        <div className="layer layer8" data-speed="2.5"></div>
        <div className="layer layer7" data-speed="3"></div>
        <div className="layer layer6" data-speed="3.5"></div>
        <div className="layer layer5" data-speed="4"></div>
        <div className="layer layer4" data-speed="4.5"></div>
        <div className="layer layer3" data-speed="5"></div>
        <div className="layer layer2" data-speed="5.5"></div>
        <div className="layer layer1" data-speed="6"></div>

        <div className="contour contour1" data-speed="6"></div>
        <div className="contour contour2" data-speed="5.5"></div>
        <div className="contour contour3" data-speed="5"></div>
        <div className="contour contour4" data-speed="4.5"></div>
        <div className="contour contour5" data-speed="4"></div>
        <div className="contour contour6" data-speed="3.5"></div>
        <div className="contour contour7" data-speed="3"></div>
        <div className="contour contour8" data-speed="2.5"></div>
        <div className="contour contour9" data-speed="2"></div>
        <div className="contour contour10" data-speed="1.5"></div>
        <div className="contour contour11" data-speed="1"></div>
        <div className="contour contour12" data-speed="0.5"></div>
      </div>
    </div>
  );
}

export default TopographicBackground;